import React, { useEffect, useRef } from "react";
import ReactAudioPlayer from "react-h5-audio-player";
import { usePlaylistContext } from "../../context/PlaylistContext";

function AudioPlayerTool({ showFilledVolume}) {
  const musicRef = useRef<any>();
  const { state, dispatch } = usePlaylistContext();
  const previousSongUrl = useRef<string>("");

  // Auto-play when a new song is set
  useEffect(() => {
    if (state.previewSong.url && 
        state.previewSong.url !== previousSongUrl.current && 
        musicRef.current?.audio?.current) {
      
      // Update the previous URL reference
      previousSongUrl.current = state.previewSong.url;
      
      // Small delay to ensure the src is loaded, then play
      const timer = setTimeout(() => {
        musicRef.current?.audio?.current?.play()
          .catch((error: any) => {
            // Autoplay was prevented, user will need to click play manually
          });
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [state.previewSong.url]);

  return (
    <ReactAudioPlayer
      className="audio-player"
      ref={musicRef}
      autoPlay={false} // Keep this false to handle autoplay manually
      showSkipControls={false}
      showJumpControls={true}
      showFilledProgress={true}
      showFilledVolume={true}
      src={state.previewSong.url}
      customIcons={{
        forward: (
          <svg
            width="30"
            height="26"
            viewBox="0 0 30 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.75 5.70866L23.75 20.292"
              stroke="#F3F4F6"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.25 4.66634L18.75 12.9997L6.25 21.333L6.25 4.66634Z"
              fill="#F3F4F6"
              stroke="#F3F4F6"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        rewind: (
          <svg
            width="30"
            height="26"
            viewBox="0 0 30 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.25 20.2913V5.70801"
              stroke="#F3F4F6"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M23.75 21.3337L11.25 13.0003L23.75 4.66699V21.3337Z"
              fill="#F3F4F6"
              stroke="#F3F4F6"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )
      }}
      layout={"stacked-reverse"}
      onPause={() => {
        dispatch({
          type: "UPDATE_SONGS_SEARCH_LIST",
          payload: state.previewSong.id,
        });
      }}

      onPlay={() => {
        dispatch({
          type: "UPDATE_SONGS_SEARCH_LIST",
          payload: state.previewSong.id,
        });
      }}
    />
  )
}

export default AudioPlayerTool